// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
// import { ConfigService, SharedConfigKey } from '@ddt-web/config-layer';
import { SharedApplicationConstants } from '@ddt-web/domain';

export class ModelNameUtil {

	public static getModelName(modelsConfig: any, associatedPortfolios: any, entityKeyName: string = ''): string {
		let modelName = entityKeyName ? modelsConfig[entityKeyName] || associatedPortfolios[entityKeyName] || '' : null;
		modelName = modelName ? modelName : modelsConfig?.name || associatedPortfolios?.name || modelsConfig?.shortName || '';

		// external name for cms models
		modelName = ModelNameUtil.getModelExternalName(modelsConfig, modelName);

		// research model name 
		const isModelResearch = modelsConfig?.managementType === 'research';
		const isTpm = modelsConfig?.id?.startsWith('TPM@');

		// Note: If a TPM is also research, it needs to have both dagger and star
		// using window['AC_CONFIG'] because otherwise, its a massive circular dependency
		const enableTpmCom: boolean = window['AC_CONFIG']?.['ENABLE_TPM_FOR_DOT_COM'] || false;
		if (isTpm && enableTpmCom) {
			modelName = '†' + modelName;
		}
		if (isModelResearch) {
			modelName = '*' + modelName;
		}
		return modelName;
	}

	/**
	 * Returns modelExternalName for CMS models if enableCmsRenaming config is set to true and modelExternalName value is present
	 * If not, returns the provided default name
	 * 
	 * @param model
	 * @param defaultName
	 * @returns {string}
	 */
	public static getModelExternalName(model: any, defaultName: string): string {
		const shouldReturnModelExternalName = model?.enableCmsRenaming && model?.modelExternalName
			&& model?.groups?.[0]?.id !== SharedApplicationConstants.MODEL_FAMILY.BLACKROCK_FAMILY_GROUP;
		return shouldReturnModelExternalName ? model?.modelExternalName : defaultName;
	}
}
